import {PostPracticeActionType, PostPracticeState} from "./types";

const initialState: PostPracticeState = {
    postReport: null,
    helpList: null,
    postResults: null,
    allPostReports: null,
    loading: false,
};
const UserReducer = (state = initialState, action: any): PostPracticeState => {
    switch (action.type) {
        case PostPracticeActionType.START_REQUEST:
            return { ...state, loading: true };
        case PostPracticeActionType.POST_REPORT_LOADED:
            return { ...state, loading: false, postReport: action.payload };
        case PostPracticeActionType.ALL_POST_REPORTS_LOADED:
            return { ...state, loading: false, allPostReports: action.payload };
        case PostPracticeActionType.HELP_LIST_LOADED:
            return { ...state, loading: false, helpList: action.payload };
        case PostPracticeActionType.POST_RESULTS_LOADED:
            return { ...state, loading: false, postResults: action.payload };
        case PostPracticeActionType.FINISH_REQUEST:
            return { ...state, loading: false };
        default:
            return state;
    }
};

export default UserReducer;
